import React, { useMemo } from "react";
import rocketImage from "../image/rocket.png";
import enrollCourseImage from "../image/enrollCourse.jpg";

const formatIndianPrice = (value) =>
  Math.round(Number(value) || 0).toLocaleString("en-IN");

const MasterclassCompletionModal = ({
  isOpen,
  onClose,
  course,
  isEnrolled,
  onEnrollNow,
  onGoToCourse,
}) => {
  const displayPrice = useMemo(
    () => course?.price || 0,
    [course?.price]
  );

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1200] flex items-center justify-center bg-black/70 px-3 py-6 sm:px-4 overflow-y-auto">
      <div className="relative w-full max-w-[1100px] my-auto">
        <button
          type="button"
          onClick={onClose}
          className="absolute -right-1 -top-1 sm:right-2 sm:top-2 z-30 flex h-9 w-9 items-center justify-center rounded-full bg-black text-xl text-white shadow-lg"
          aria-label="Close"
        >
          ×
        </button>

        <div
          className="relative overflow-hidden rounded-2xl"
          style={{
            backgroundImage: `url(${
              course?.courseEntrollBanner?.[0] || enrollCourseImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="relative z-10 px-4 sm:px-6 md:px-8 lg:px-16 py-8 sm:py-10 md:py-12 text-white">
            <p className="max-w-[1400px] text-base sm:text-[18px] md:text-[20px] leading-[165%] text-white/95">
              {course?.courseEntrollDescription}
            </p>

            <div className="relative mt-6">
              <img
                src={rocketImage}
                alt=""
                className="
                  absolute
                  right-0
                  top-[-50px] sm:top-[-60px] md:top-[-70px]
                  w-[120px] sm:w-[180px] md:w-[240px] lg:w-[320px]
                  object-contain
                  z-20
                  pointer-events-none
                "
              />

              <div
                className="
                  inline-flex
                  flex-col
                  sm:flex-row
                  border
                  border-white/40
                  rounded-[20px]
                  overflow-hidden
                  bg-[#000D36]/25
                  backdrop-blur-sm
                  relative
                  z-10
                  w-full
                  sm:w-auto
                "
              >
                <div className="px-4 sm:px-6 md:px-8 py-5 sm:py-6 w-full sm:w-auto">
                  <h3 className="text-xl sm:text-[22px] font-semibold text-white/90">
                    Program Value
                  </h3>
                  <div className="mt-3 sm:mt-4 flex flex-wrap items-center gap-2 sm:gap-3">
                    <span className="text-[#FF5A00] text-3xl sm:text-[40px] font-bold line-through">
                      ₹1,00,000
                    </span>
                    <span className="bg-[#1557FF] px-2 sm:px-3 py-1 rounded text-xs sm:text-sm font-semibold">
                      +GST
                    </span>
                  </div>
                </div>

                <div className="w-full sm:w-[3px] h-[3px] sm:h-auto bg-[#FF5A00]" />

                <div className="px-4 sm:px-6 md:px-8 py-5 sm:py-6 w-full sm:w-auto">
                  <h3 className="text-xl sm:text-[22px] font-semibold text-white/90">
                    Today Only
                  </h3>
                  <div className="mt-3 sm:mt-4 flex flex-wrap items-center gap-2 sm:gap-3">
                    <span className="text-[#FF5A00] text-3xl sm:text-[40px] font-bold">
                      ₹{formatIndianPrice(displayPrice)}/-
                    </span>
                    <span className="bg-[#1557FF] px-2 sm:px-3 py-1 rounded text-xs sm:text-sm font-semibold">
                      +GST
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-6 sm:mt-8">
              {isEnrolled ? (
                <div className="relative inline-flex p-3 border-2 border-dashed border-white/70 rounded-md w-full sm:w-auto">
                  <span className="absolute -top-2 -left-2 h-3.5 w-3.5 rounded-full bg-white" />
                  <span className="absolute -top-2 -right-2 h-3.5 w-3.5 rounded-full bg-white" />
                  <span className="absolute -bottom-2 -left-2 h-3.5 w-3.5 rounded-full bg-white" />
                  <span className="absolute -bottom-2 -right-2 h-3.5 w-3.5 rounded-full bg-white" />
                  <button
                    type="button"
                    onClick={onGoToCourse}
                    className="
                      w-full sm:w-auto
                      h-[56px] sm:h-[66px]
                      px-6 sm:px-8 md:px-12
                      bg-[#FC3602]
                      hover:bg-[#e43100]
                      text-white
                      text-xl sm:text-2xl
                      font-bold
                      uppercase
                      rounded-[8px]
                      transition
                    "
                  >
                    GO TO COURSE
                  </button>
                  <span className="absolute -right-6 -bottom-7 sm:-right-7 sm:-bottom-8">
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden
                    >
                      <path
                        d="M3 2L21 10L13 13L10 21L3 2Z"
                        fill="#FC3602"
                        stroke="#FC3602"
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
              ) : (
                <>
                  <div className="relative inline-flex p-3 border-2 border-dashed border-white/70 rounded-md w-full sm:w-auto">
                    <span className="absolute -top-2 -left-2 h-3.5 w-3.5 rounded-full bg-white" />
                    <span className="absolute -top-2 -right-2 h-3.5 w-3.5 rounded-full bg-white" />
                    <span className="absolute -bottom-2 -left-2 h-3.5 w-3.5 rounded-full bg-white" />
                    <span className="absolute -bottom-2 -right-2 h-3.5 w-3.5 rounded-full bg-white" />
                    <button
                      type="button"
                      onClick={onEnrollNow}
                      className="
                        w-full sm:w-auto
                        h-[56px] sm:h-[66px]
                        px-6 sm:px-8 md:px-12
                        bg-[#FC3602]
                        hover:bg-[#e43100]
                        text-white
                        text-xl sm:text-2xl
                        font-bold
                        uppercase
                        rounded-[8px]
                        transition
                      "
                    >
                      ENROLL NOW
                    </button>
                    <span className="absolute -right-6 -bottom-7 sm:-right-7 sm:-bottom-8">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden
                      >
                        <path
                          d="M3 2L21 10L13 13L10 21L3 2Z"
                          fill="#FC3602"
                          stroke="#FC3602"
                          strokeWidth="1.5"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  {/* <p className="mt-2 sm:mt-3 text-center sm:text-left text-lg sm:text-[18px] text-white/90">
                    No Cost EMI Available
                  </p> */}
                </>
              )}
            </div>

            {course?.bestSuitFor?.length > 0 && (
              <div className="mt-8 sm:mt-10 text-center sm:text-left">
                <p className="text-white/80 text-sm sm:text-base mb-3 sm:mb-4">
                  Best suited for ➜
                </p>
                <div className="flex flex-wrap gap-3 sm:gap-4 justify-center sm:justify-start">
                  {course.bestSuitFor.map((item, index) => (
                    <span
                      key={index}
                      className="
                        px-4 sm:px-6
                        h-10 sm:h-11
                        rounded-full
                        bg-black
                        border-2
                        border-[grey]
                        flex
                        items-center
                        justify-center
                        text-white
                        text-xs sm:text-sm
                        font-medium
                        whitespace-nowrap
                      "
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterclassCompletionModal;
